export default __webpack_public_path__ + "static/media/icon-lmi-20th.e9754e93.svg";